// Subscription API - handles subscription operations (pause/resume/cancel/update) with planId
import { getData } from '../plugins/ApiCalls'

export function pauseSubscription(id, reason) {
  return getData('subscriptions/' + id + '/pause', {
    params: reason ? { reason } : {}
  })
}

export function resumeSubscription(id) {
  return getData('subscriptions/' + id + '/resume')
}

export function cancelSubscription(id, reason) {
  return getData('subscriptions/' + id + '/cancel', {
    params: reason ? { reason } : {}
  })
}

export function updateSubscription(id, params) {
  return getData('subscriptions/' + id + '/update', {
    params: params || {}
  })
}

export function getPastDueSubscription(id) {
  return getData('subscriptions/' + id + '/past-due')
}

export function listPayment(id) {
  return getData('subscriptions/' + id + '/list-payment')
}

export function listDiscountCoupon() {
  return getData('subscriptions/list-coupon')
}

export function listTransaction(id) {
  return getData('subscriptions/' + id + '/list-transaction')
}
